"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarFooter = exports.CalendarBody = exports.CalendarHeader = exports.CalendarPanel = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var justify_1 = require("../justify");
var config_context_1 = require("../_util/config-context");
exports.CalendarPanel = react_1.default.forwardRef(function CalendarPanel(_a, ref) {
    var _b;
    var className = _a.className, children = _a.children, _c = _a.rangeMode, rangeMode = _c === void 0 ? false : _c, _d = _a.timeMode, timeMode = _d === void 0 ? false : _d, props = tslib_1.__rest(_a, ["className", "children", "rangeMode", "timeMode"]);
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", tslib_1.__assign({ ref: ref, className: classnames_1.default(classPrefix + "-calendar", className, (_b = {},
            _b[classPrefix + "-calendar--date-range"] = rangeMode,
            _b[classPrefix + "-calendar--time"] = timeMode,
            _b)) }, props), children));
});
exports.CalendarPanel.displayName = "CalendarPanel";
function CalendarHeader(_a) {
    var style = _a.style, className = _a.className, children = _a.children;
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-calendar__header", className), style: style }, children));
}
exports.CalendarHeader = CalendarHeader;
CalendarHeader.displayName = "CalendarHeader";
function CalendarBody(_a) {
    var style = _a.style, className = _a.className, children = _a.children;
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-calendar__body", className), style: style }, children));
}
exports.CalendarBody = CalendarBody;
CalendarBody.displayName = "CalendarBody";
function CalendarFooter(_a) {
    var style = _a.style, className = _a.className, left = _a.left, right = _a.right;
    var classPrefix = config_context_1.useConfig().classPrefix;
    return (react_1.default.createElement("div", { className: classnames_1.default(classPrefix + "-calendar__footer", className), style: style },
        react_1.default.createElement(justify_1.Justify, { left: left, right: right })));
}
exports.CalendarFooter = CalendarFooter;
CalendarFooter.displayName = "CalendarFooter";
exports.default = {
    Panel: exports.CalendarPanel,
    Header: CalendarHeader,
    Body: CalendarBody,
    Footer: CalendarFooter,
};
//# sourceMappingURL=CalendarPart.js.map